module.exports = __webpack_public_path__ + "static/media/slide-4.0d380245.png";